<template>
  <div id="app" class="centered-container">
    <md-content class="md-elevation-3">
      <div class="title">
        <div class="md-title">
          Industrial Control Tower
        </div>
        <div v-if="!authError" class="md-body-1">
          Please login
        </div>
        <div v-else class="error">
          Wrong username or password
        </div>
      </div>

      <div class="form">
        <md-field :class="usernameError">
          <label>Username</label>
          <md-input v-model="username" autofocus />
          <span class="md-error">Username required</span>
        </md-field>

        <md-field md-has-password :class="passwordError">
          <label>Password</label>
          <md-input v-model="password" type="password" @keyup="keyUp" />
          <span class="md-error">Password required</span>
        </md-field>
      </div>

      <div class="actions md-layout md-alignment-center-space-between">
        <md-button class="md-raised md-primary" @click.prevent="login">
          Log in
        </md-button>
      </div>

      <div v-if="loading" class="loading-overlay">
        <md-progress-spinner md-mode="indeterminate" :md-stroke="2" />
      </div>
    </md-content>
    <div class="background" />
  </div>
</template>

<script>
import axios from 'axios'
import { getLoginPath }  from './pathHelpers'
import { isNullOrUndefined } from 'util';

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      loading: false,
      username: '',
      password: '',
      usernameHasError: false,
      passwordHasError: false,
      authError: false
    };
  },
  computed: {
    passwordError() {
      return {
        'md-invalid': this.passwordHasError
      };
    },
    usernameError() {
      return {
        'md-invalid': this.usernameHasError
      };
    }
  },
  methods: {
    login() {
      if (this.password == '') {
        this.passwordHasError = true;
      }
      else {
        this.passwordHasError = false;
      }

      if (this.username == '') {
        this.usernameHasError = true;
      }
      else {
        this.usernameHasError = false;
      }

      if (this.password != '' && this.username != '') {
        this.loading = true;
        const path = getLoginPath();
        var urlParams = new URLSearchParams(window.location.search);
        let url = urlParams.get('url');
        const payload = {
          "username": this.username,
          "password": this.password
        };
        axios.post(path, payload).then((res) => {
          if (res.status == 200 ) {
            if (!isNullOrUndefined(url) && url != "") {
              location.replace(url);
            } else {
              location.replace('https://portal.industrialcontroltower.com/');
            }
          }
        }).catch(() => {
          this.loading = false;
          this.authError = true;
        });
        this.clearForm();
      }
    },
    clearForm() {
      this.username = '';
      this.password = '';
    },
    keyUp(e) {
      if (e.key == 'Enter') {
        this.login();
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Saira&display=swap');

#app {
  text-align: center;
  font-family: 'Saira', sans-serif; 
}

button {
  margin: 0px 5px 0px 5px;
}

input {
  margin: 0px 5px 5px 5px;
}

.centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;
}

.title {
  text-align: center;
  margin-bottom: 30px;
}

.md-content {
  z-index: 1;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  position: relative;
}

.loading-overlay {
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}

.actions {
  float: right;
}

.error {
  color:#ff1745;
}
</style>